import { Component, OnInit } from '@angular/core';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { Subscription } from 'rxjs';
import { Translators } from 'src/app/services/shared/translators.service';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth/auth.service';
import Swal from 'sweetalert2';
import { GuiToolsService } from 'src/app/services/shared/gui-tools.service';

@Component({
    selector: 'app-gym-coaching-banner',
    templateUrl: './gym-coaching-banner.component.html',
    styleUrls: ['./gym-coaching-banner.component.scss']
})
export class GymCoachingBannerComponent implements OnInit {


    testRoutes = [
        { name: 'Online Training School', path: '/online-training-school' },
        { name: 'Distance Learning', path: '/distance-learning' },
        { name: 'Language School', path: 'language-school' }, 
        { name: 'Modern Schooling', path: 'modern-schooling' },
        { name: 'Yoga Training', path: 'yoga-training' },
        { name: 'Health Coaching', path: 'health-coaching' },
        { name: 'Kindergarten', path: 'kindergarten' },
        { name: 'Gym Coaching', path: 'gym-coaching' },
        { name: 'Learning Management', path: 'learning-management' },
        { name: 'About 1', path: 'about-1' },
        { name: 'About 2', path: 'about-2' },
        { name: 'About 3', path: 'about-3' },
        { name: 'About 4', path: 'about-4' },
        { name: 'Success Story', path: 'success-story' },
        { name: 'Teacher', path: 'teacher' },
        { name: 'FAQ', path: 'faq' },
        { name: 'Coming Soon', path: 'coming-soon' },
        { name: 'Purchase Guide', path: 'purchase-guide' },
        { name: 'Privacy Policy', path: 'privacy-policy' },
        { name: 'Terms of Service', path: 'terms-of-service' },
        { name: 'Courses 1', path: 'courses-1' },
        { name: 'Courses 2', path: 'courses-2' },
        { name: 'Courses 3', path: 'courses-3' },
        { name: 'Courses 4', path: 'courses-4' },
        { name: 'Courses 5', path: 'courses-5' },
        { name: 'Courses 6', path: 'courses-6' },
        { name: 'Courses 7', path: 'courses-7' },
        { name: 'Single Courses 1', path: 'single-courses-1' },
        { name: 'Single Courses 2', path: 'single-courses-2' },
        { name: 'Profile', path: 'profile' },
        { name: 'Profile Quiz', path: 'profile-quiz' },
        { name: 'Membership Levels', path: 'membership-levels' },
        { name: 'Become a Teacher', path: 'become-a-teacher' },
        { name: 'Categories', path: 'categories' },
        { name: 'Events', path: 'events' },
        { name: 'Single Events', path: 'single-events' },
        { name: 'Products List 1', path: 'products-list-1' },
        { name: 'Products List 2', path: 'products-list-2' },
        { name: 'Cart', path: 'cart' },
        { name: 'Checkout', path: 'checkout' },
        { name: 'Single Products', path: 'single-products' },
        { name: 'Gallery', path: 'gallery' },
        { name: 'Blog 1', path: 'blog-1' },
        { name: 'Blog 2', path: 'blog-2' },
        { name: 'Blog 3', path: 'blog-3' },
        { name: 'Blog 4', path: 'blog-4' },
        { name: 'Blog 5', path: 'blog-5' },
        { name: 'Single Blog 1', path: 'single-blog-1' },
        { name: 'Single Blog 2', path: 'single-blog-2' },
        { name: 'Single Blog 3', path: 'single-blog-3' },
        { name: 'Contact', path: 'contact' },
        { name: 'Andorra Apply', path: 'andorra-apply' },
        { name: 'Andorra Documentos', path: 'andorra-documentos' },
        { name: 'Curso Habilitado', path: 'curso-habilitado' },
        { name: 'Andorra Apply Logueado', path: 'andorra-apply-logueado' },
        { name: 'Andorra Documentos Logueado', path: 'andorra-documentos-logueado' },
        { name: 'Curso Habilitado Dos', path: 'curso-habilitado-dos' },
        { name: 'Oferta Laboral País', path: 'oferta-laborar-pais' },
        { name: 'Oferta Laboral Detalle', path: 'oferta-laborar-detalle' },
        { name: 'Postular', path: 'postular' },
        { name: 'Oferta Trabajo Gral', path: 'oferta-trabajo-gral' },
        { name: 'Oferta Trabajo Resumen', path: 'oferta-trabajo-resumen' },
        { name: 'Oferta Trabajo Resumen Aprobado', path: 'oferta-trabajo-resumen-aprobado' },
        { name: 'Error', path: 'error' }
    ];
    
    idioma: Subscription;

    gymBannerSlides: OwlOptions = {
        items: 1,
        nav: true,
        loop: true,
        dots: false,
        autoplay: false,
        animateIn: 'fadeIn',
        animateOut: 'fadeOut',
        autoplayHoverPause: true,
        autoplayTimeout: 10000,
        navText: [
            '<i class=\'flaticon-chevron\'></i>',
            '<i class=\'flaticon-right-arrow\'></i>'
        ],
        responsive: {
            0: {
                autoHeight: true
            },
            576: {
                autoHeight: false
            },
            768: {
                autoHeight: false
            },
            992: {
                autoHeight: false
            }
        }
    };

    bgImage = [
        {
            img: 'assets/img/gym-banner-bg.jpg'
        }
    ];

    constructor(
        private translatorService: Translators,
        private router: Router,
        private authservice: AuthService,
        private guiToolsService: GuiToolsService,
    ) {
        // this.idioma = this.translatorService.getIdiomaSeleccionado().subscribe(resp => {
        //     this.idioma = resp;
        //   });
    }

    ngOnInit(): void {
    }

    useLanguage(idioma: string){
        this.translatorService.setIdiomaSeleccionado(idioma);
    }

    navigateRoot(url: string){
        this.router.navigateByUrl(url);
    }

    getGuestToken() {
        Swal.showLoading()
        this.authservice.getGuestToken();
    }

    navigateTo(path: string) {
        this.router.navigate([path]);
      }


}
